import { defineComponent as _defineComponent } from 'vue'
import UiAuditInfo from '@/components/UiAuditInfo.vue';
import { Permission, ScriptModel } from '@/types';
import { CheckCircleIcon, PencilAltIcon, XCircleIcon } from '@heroicons/vue/outline';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScriptListItem',
  props: {
    modelValue: {
        type: Object as PropType<ScriptModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const trimText = (text: string, limit: number) => {
    if (text.length <= limit) {
        return text;
    } else {
        return text.slice(0, limit - 3) + '...';
    }
};
const emit = __emit;
const handleActivateClick = () => emit('activate', props.modelValue);
const handleInactivateClick = () => emit('inactivate', props.modelValue);

const __returned__ = { props, trimText, emit, handleActivateClick, handleInactivateClick, UiAuditInfo, get Permission() { return Permission }, get CheckCircleIcon() { return CheckCircleIcon }, get PencilAltIcon() { return PencilAltIcon }, get XCircleIcon() { return XCircleIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})